<button class="close" (click)="close()" [style.top]="top" [style.bottom]="bottom" [style.right]="right" [style.left]="left" mat-icon-button>
  <i class="material-icons">close</i>
</button>